export default {
  parse: () => {
    return { href: '' }
  },
}
